import { fork, take, put } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { takeEvery } from 'redux-saga';

import * as actions from 'actions';
import * as api from 'api';

export function* watchForSearchInitiate() {
  while(true) { // eslint-disable-line no-constant-condition
    const action = yield take(actions.SEARCH_INITIATE);
    if (action.term.length >= process.env.KOOTH_SEARCH_MIN_CHARS) {
      yield put(push({pathname: '/search', search: `?term=${action.term}`}));
    } else {
      yield put(actions.infoShow('errors', 'Please try searching for at least 3 characters.'));
    }
  }
}

export function* watchForSearchItemsFetchSuccess() {
  while(true) { // eslint-disable-line no-constant-condition
    const action = yield take(actions.SEARCH_ITEMS_FETCH_SUCCESS);
    const searchResults = action.result.searchResults;

    const comments = searchResults.entities.comments;
    const magazineArticles = searchResults.entities.magazineArticles;
    const forumThreads = searchResults.entities.forumThreads;

    // notify the corresponding byId reducers
    if (magazineArticles) {
      yield put(actions.magazineArticlesReceived({
        magazineArticlesIds: Object.keys(magazineArticles),
        entities: { magazineArticles }
      }));
    }

    if (comments) {
      yield put(actions.commentsReceived({
        commentsIds: Object.keys(comments),
        entities: { comments }
      }));
    }

    if (forumThreads) {
      yield put(actions.forumThreadsReceived({
        forumThreadsIds: Object.keys(forumThreads),
        entities: { forumThreads }
      }));
    }

    yield put(actions.searchResultsReceived(
      action.page,
      {
        searchResultsIds: action.result.searchResults.result.map(result => `${result.schema}-${result.id}`),
        meta: action.result.meta
      },
      action.query,
      action.searchQueryString
    ));
  }
}

export default function* backgroundSaga(socket, request) {
  yield [
    fork(watchForSearchInitiate),
    fork(takeEvery, actions.SEARCH_ITEMS_FETCH, request(api.searchItemsFetch, 'page', 'query')),
    fork(watchForSearchItemsFetchSuccess)
  ];
}



/** WEBPACK FOOTER **
 ** ./src/members/state/search/sagas.js
 **/